export const SYMBOL_CHANGED = "SYMBOL_CHANGED";
export const GET_SYMBOLS = "GET_SYMBOLS";
export const GET_ORDERS = "GET_ORDERS";
export const APPEND_ORDERS = "APPEND_ORDERS";
export const GET_ACCOUNTS = "GET_ACCOUNTS";
export const SET_ACTIVE_PROFILE = "SET_ACTIVE_PROFILE";
export const SELECT_ORDER = "SELECT_ORDER";
export const SET_NOTIFICATION_COUNT = "SET_NOTIFICATION_COUNT";
export const DECREMENT_NOTIFICATION_COUNT = "DECREMENT_NOTIFICATION_COUNT";
export const INCREMENT_NOTIFICATION_COUNT = "INCREMENT_NOTIFICATION_COUNT";
export const GET_EXCHANGES = "GET_EXCHANGES";
export const GET_ExchangesOriginal = "GET_ExchangesOriginal";
export const SET_DARK_MODE = "SET_DARK_MODE";
export const GET_SIGNALR = "GET_SIGNALR";
export const SET_SYMBOL_DETAILS = "SET_SYMBOL_DETAILS";
export const SET_PROFILES = "SET_PROFILES";
export const SET_PROFILE_ID_SELECTED = "SET_PROFILE_ID_SELECTED";
export const SET_SUBSCRIBED_SYMBOLS = "SET_SUBSCRIBED_SYMBOLS";
export const SET_IS_SUBSCRIBED_SYMBOLS_CHANGED = "SET_IS_SUBSCRIBED_SYMBOLS_CHANGED";
export const SET_IS_LOADER_VISIBLE = "SET_IS_LOADER_VISIBLE";
export const SET_IS_NEW_WORKSPACE_LAYOUT = "SET_IS_NEW_WORKSPACE_LAYOUT";
export const SET_IS_ALERT_DELETED = "SET_IS_ALERT_DELETED";
export const SET_IS_CONDITIONAL_ORDER_DELETED = "SET_IS_CONDITIONAL_ORDER_DELETED";
export const SET_CONFIG = "SET_CONFIG";
export const SET_IS_SIDEBAR_OPEN = "SET_IS_SIDEBAR_OPEN";
export const SET_IS_TICKER_VISIBLE = "SET_IS_TICKER_VISIBLE";
export const LINKING_TAP = "LINKING_TAP";
export const LINKING_ALL_TAPS_OPEN = "LINKING_ALL_TAPS_OPEN";
export const CLOSE_BTN = "CLOSE_BTN";
export const SET_PERM_DATA = "SET_PERM_DATA";
export const SET_IS_SIDEBAR_MENU_OPEN = "SET_IS_SIDEBAR_MENU_OPEN";
export const SET_IS_NEW_WORKSPACE_CHART_LAYOUT = "SET_IS_NEW_WORKSPACE_CHART_LAYOUT";
export const WORKSPACE_CHART_PROFILES = "WORKSPACE_CHART_PROFILES";
export const SET_IS_NEW_WORKSPACE_CHART_ADVANCE_FOCOUS = "SET_IS_NEW_WORKSPACE_CHART_ADVANCE_FOCOUS";
export const SET_ADVANCE_SEARCH_SYMBOL = "SET_ADVANCE_SEARCH_SYMBOL";
export const GET_EXCHANGES_UPDATE = "GET_EXCHANGES_UPDATE";
export const UPDATE_SELECTED_PROFILE = "UPDATE_SELECTED_PROFILE";
export const UPDATE_PROFILE_LIST = "UPDATE_PROFILE_LIST";
export const IS_PROFILES_UPDATED = "IS_PROFILES_UPDATED";
export const IS_ADD_DELETE_PROFILE = "IS_ADD_DELETE_PROFILE";
export const GET_INDEXES = "GET_INDEXES";
export const UPDATE_ENABLE_EXPAND_ROW = "UPDATE_ENABLE_EXPAND_ROW";
export const UPDATE_RFREASH_TIME_SETTINGS = "UPDATE_RFREASH_TIME_SETTINGS";
export const UPDATE_NUM_OF_TRADING = "UPDATE_NUM_OF_TRADING";
export const SYMBOL_TRADES_DATAFEED = "SYMBOL_TRADES_DATAFEED";
export const MARKET_WATCH_UPDATE = "MARKET_WATCH_UPDATE";
export const MARKET_DEPTH_UPDATE = "MARKET_DEPTH_UPDATE";
export const SET_SUBSCRIBED_SYMBOLS_TICKER = "SET_SUBSCRIBED_SYMBOLS_TICKER";
export const SET_SYMBOLS_TO_SUBSCRIBED = "SET_SYMBOLS_TO_SUBSCRIBED";
export const ORDER_IS_UPDATED = "ORDER_IS_UPDATED";
export const ORDER_LIST_DATAFEED = "ORDER_LIST_DATAFEED";
export const SET_DEFAULT_WORKSPACE = "SET_DEFAULT_WORKSPACE";
export const SET_WORKSPACE_LAYOUTS_NUMBER = "SET_WORKSPACE_LAYOUTS_NUMBER";
export const SET_ACTIVE_PROFILE_FOR_DEFAULT_WORKSPACE = "SET_ACTIVE_PROFILE_FOR_DEFAULT_WORKSPACE";
export const SET_ORDER_SELECTED_FALSE = "SET_ORDER_SELECTED_FALSE";
export const SYMBOL_TIME_SALE_SUB = "SYMBOL_TIME_SALE_SUB";
export const SYMBOL_MARKET_DEPTH_SUB = "SYMBOL_TIME_SALE_SUB";
export const UPDATE_SYMBOL_TIME_SALE_SUB = "UPDATE_SYMBOL_TIME_SALE_SUB";
export const SET_MAEKET_FOR_MARKET_OVER_VIEW_PROFILE = "SET_MAEKET_FOR_MARKET_OVER_VIEW_PROFILE";
export const MARKET_TRADES = "MARKET_TRADES";
export const SELECTED_ACCOUNT_FROM_PORTFOLIO_WORKSPACE = "SELECTED_ACCOUNT_FROM_PORTFOLIO_WORKSPACE";
export const GET_INDEXES_UPDATE = "GET_INDEXES_UPDATE";
export const SET_SELECT_SYMBOL_FROM_PORTFOLIO = "SET_SELECT_SYMBOL_FROM_PORTFOLIO";
export const SELECT_PREFERRED_SYMBOL = "SELECT_PREFERRED_SYMBOL";
export const SET_PORTFOLIO_Data = "SET_PORTFOLIO_Data";
export const SYBMOL_QTY_TO_SELL = "SYBMOL_QTY_TO_SELL";
export const selected_Row_From_MW = "selected_Row_From_MW";
export const IS_Row_In_MW_Clicked = "IS_Row_In_MW_Clicked";
export const PORTFOLIO_FIRST_REQUEST = "PORTFOLIO_FIRST_REQUEST";
export const CHECK_CONNECTION = "CHECK_CONNECTION";
export const SELECT_PREFERRED_EXCHANGE = "SELECT_PREFERRED_EXCHANGE";
export const USER_SETTINGS = "USER_SETTINGS";
export const USER_WORKSPACES_SETTINGS = "USER_WORKSPACE_SETTINGS";
export const AVG_INDEXES = "AVG_INDEXES";
export const ENABLE_TRADE_TICKER = "ENABLE_TRADE_TICKER";
export const ENABLE_ROUND_TICKER = "ENABLE_ROUND_TICKER";
export const Is_Mobile_Size = "Is_Mobile_Size";
export const GET_LOOKUPS = "GET_LOOKUPS";
export const GET_SectorOfMarket = "GET_SectorOfMarket";
export const Active_Workspace_UniqueID = "Active_Workspace_UniqueID";
export const get_ID_Validity_Result = "get_ID_Validity_Result";
export const Get_Default_AccountInfo = "Get_Default_AccountInfo";
export const get_BasketOrder = "get_BasketOrder";
export const get_updateFromBasketOrder = "get_updateFromBasketOrder";
export const get_basketOrderObject = "get_basketOrderObject";
export const get_GroupName = "get_GroupName";
export const GET_EXCHANGES_UPDATE_EnableTags = "GET_EXCHANGES_UPDATE_EnableTags";
//mustafa
export const Get_TradeMarket_Object = "Get_TradeMarket_Object";
export const From_TradeMarket = "From_TradeMarket";


export const Selected_Account_Summaries = "Selected_Account_Summaries";

